import { getFeatureConfig } from '@luna/feature-config';

import type { RefreshTokenOptions } from './refresh/types';
import { getTokenBodyFromConfig } from './strategy/fetchUtils';
import type { AuthConfig } from './types';
import type { GetTokenResponse } from './strategy/tokenResponseTypes';

export const getTokenHeaders = (): Record<string, string> => {
    return {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
    };
};

export const getTokenUrl = (config: RefreshTokenOptions['config']): string => {
    const { tokenUrl } = config.auth;

    if (
        getFeatureConfig((featureConfig) => featureConfig?.reverseProxyVersion) === 'v2' &&
        config.reverseProxyUrl2
    ) {
        return `${config.reverseProxyUrl2}/${tokenUrl}`;
    }

    if (config.reverseProxyUrl) {
        return `${config.reverseProxyUrl}/${tokenUrl}`;
    }

    return tokenUrl;
};

export const fetchTokenurl = (config: AuthConfig, code?: string): Promise<GetTokenResponse> => {
    const body = getTokenBodyFromConfig(config, code);

    return fetch(getTokenUrl(config), {
        method: 'POST',
        headers: getTokenHeaders(),
        body,
        credentials: 'same-origin',
    }).then((response) => {
        if (!response.ok) {
            throw response;
        }
        return response.json() as Promise<GetTokenResponse>;
    });
};
